import { useEffect, useState } from "react";
import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import BTLogo from "@assets/bt-icon-white.svg";
import { getIconSrc } from "@components/Icon/utils/helpers";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { PulsePageControlContentProps } from "@features/pulse/utils/types";
import PulseDesktopPage from "@features/pulse/variant/control/page/PulseDesktopPage";
import PulseMobilePage from "@features/pulse/variant/control/page/PulseMobilePage";
import { useWindowSize } from "@hooks/useWindowSize";
import { contactFormUrl } from "@pages/Article/components/ArticlePurchaseLink/constants";

/**
 * PulseControlLayout is a React component that renders the layout for the Pulse control variant.
 */
const PulseControlLayout = ({
  sortedPulseArticles,
  activeArticle,
  handleNavigateLeftCard,
  handleNavigateRightCard,
  handleSetActiveArticle,
}: PulsePageControlContentProps): React.ReactElement => {
  const [backToBt, setBackToBt] = useState("");

  const { isScreenLG } = useWindowSize();

  useEffect(() => {
    const path = sessionStorage.getItem("pulse_back_path") || "/";
    setBackToBt(path);
  }, []);

  return (
    <div
      className="flex min-h-svh w-full flex-col bg-[#121212]"
      data-testid="pulse-page-control-content"
    >
      <div className="relative z-20 hidden justify-between p-4 pb-0 lg:flex">
        <Link to={`${RouteFactory.home}?ref=pulse`} reloadDocument>
          <img src={BTLogo} width={200} height={18} alt="The Business Times" />
        </Link>

        <Link to={`${backToBt}?ref=pulse`} reloadDocument>
          <img
            src={getIconSrc(IconTypeEnum.closeWhite)}
            width={36}
            height={36}
            alt="close"
          />
        </Link>
      </div>

      {isScreenLG ? (
        <PulseDesktopPage
          sortedPulseArticles={sortedPulseArticles}
          activeArticle={activeArticle}
          handleNavigateRightCard={handleNavigateRightCard}
          handleNavigateLeftCard={handleNavigateLeftCard}
          backToBt={backToBt}
        />
      ) : (
        <PulseMobilePage
          sortedPulseArticles={sortedPulseArticles}
          activeArticle={activeArticle}
          handleNavigateRightCard={handleNavigateRightCard}
          handleNavigateLeftCard={handleNavigateLeftCard}
          handleSetActiveArticle={handleSetActiveArticle}
          backToBt={backToBt}
        />
      )}

      <div className="absolute bottom-6 right-6 z-10 hidden font-poppins text-4xs font-light tracking-2% text-gray-550 lg:block">
        AI-generated summary.{" "}
        <a
          target="_blank"
          href={contactFormUrl}
          className="underline-offset-4 hover:underline"
          rel="noreferrer"
        >
          Feedback.
        </a>
      </div>
    </div>
  );
};

export default PulseControlLayout;
